/**
 * Helper function to safely convert date to ISO string format (YYYY-MM-DD)
 * Used for DateField components that expect ISO string format
 *
 * @param {Date|string|null|undefined} dateValue - The date value to format
 * @returns {string} - ISO string (YYYY-MM-DD) or empty string
 */
export const formatDateValue = (dateValue) => {
  if (!dateValue) return "";

  // If it's a Date object, check if it's valid
  if (dateValue instanceof Date) {
    if (!isNaN(dateValue.getTime())) {
      const formatted = dateValue.toISOString().split("T")[0];
      // console.log(
      //   "formatDateValue - Date object to ISO:",
      //   dateValue,
      //   "->",
      //   formatted,
      // );
      return formatted;
    }
    return "";
  }

  // If it's a string, return as-is
  if (typeof dateValue === "string") {
    console.log("formatDateValue - String:", dateValue);
    return dateValue;
  }

  console.log("formatDateValue - No value or invalid type:", dateValue);
  return "";
};
